export function popups() {
    $(window).on("load", function () {
        const mainWrap = $("body");
        const videoPopup = $('#popup-video');
        const imagePopup = $('#popup--image');

        function closePopup() {
            imagePopup.find('.image-wrap').html('');
            videoPopup.find('.video-wrap').html('');
            videoPopup.find('.video-caption strong').text('');
            videoPopup.find('.video-caption span').text('');
            $(".popup").removeClass("active");
            mainWrap.removeClass("popup-open");
        }

        $(document).on("click", ".popup-link", function (event) {
            event.preventDefault();

            let $this = $(this);
            let $url = $this.attr("href");
            let parseUrl = $url.split('#');
            let $target = '#' + parseUrl[1];

            if ($this.attr('data-report')) {
                $('#popup-images .ajax-holder-reports').html('');

                let data = {
                    'action': 'load_full_report',
                    'report': $this.attr('data-report')
                };

                $.ajax({
                    url: ajaxvars.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                    },
                    success: function (response) {
                        $($target).find('.ajax-holder-reports').html(response);

                        let $slider = $($target).find('.ajax-holder-reports').find(".slider-reports"),
                            $holder = $slider.closest('.wrap-slider-reports');

                        $slider.slick({
                            arrows: true,
                            infinite: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            prevArrow: $holder.find(".common-slider-controls .prev-arrow"),
                            nextArrow: $holder.find(".common-slider-controls .next-arrow"),
                        });
                    },
                    complete: function () {
                        $($target).addClass("active").fadeIn(300);
                        mainWrap.addClass("popup-open");
                    }
                });

            } else {
                if ($this.hasClass('popup-image')) {
                    let image;
                    const href = $this.attr("data-image");

                    image = `<img src="${href}" alt="image">`;

                    imagePopup.find('.image-wrap').append(image);
                }

                if ($this.hasClass('play-video')) {
                    let video;
                    const href = $this.attr("data-video");
                    const text = $this.attr("data-text");

                    if (href !== '#') {
                        const embedSrc = href + '?enablejsapi=1&autoplay=0';
                        video = `<iframe src="${embedSrc}" frameborder="0" allow="autoplay" allowfullscreen playsinline></iframe>`
                    }

                    if (text) {
                        videoPopup.find('.video-caption strong').text('VIDEO:');
                        videoPopup.find('.video-caption span').text(text)
                    } else {
                        videoPopup.find('.video-caption strong').text()
                    }

                    videoPopup.find('.video-wrap').append(video);

                    const videoIframe = videoPopup.find('iframe');

                    setTimeout(() => {
                        if (videoIframe.length) {
                            videoIframe[0].contentWindow.postMessage('{"event":"command", "method":"play", "func":"' + 'playVideo' + '","args":""}', '*');
                        }
                    }, 1700);

                }

                $($target).addClass("active").fadeIn(300);
                mainWrap.addClass("popup-open");
            }

        }).on("click", ".popup-close", function () {
            closePopup.call(this);
        });

        $(".popups").on("click", function (event) {
            if (!$(event.target).closest(".popup-holder").length) {
                closePopup.call(this);
            }
        });

        //Cookie popup
        const cookiePopup = $('#popup-cookie');
        if (cookiePopup.length && document.cookie.indexOf("corporatePrivacyLevel=") < 0) {
            cookiePopup.addClass("active").fadeIn(300);
            mainWrap.addClass("popup-open");

            let btnCookie = cookiePopup.find('.link');
            if (btnCookie.length) {
                btnCookie.on('click', function (e) {
                    e.preventDefault();

                    $('.info-cookie, .manage-cookie').toggleClass('hidden');
                });
            }

            let manageCookie = $('.manage-cookie');
            if (manageCookie.find("input[type='checkbox']").length) {
                manageCookie.find("input[type='checkbox']").each(function () {
                    $(this).on('change', function () {
                        $(this).parent().toggleClass('checked');
                    });
                });
            }

            cookiePopup.find('.button').on('click', function (e) {
                e.preventDefault();

                let expiry = new Date();
                expiry.setMonth(expiry.getMonth() + 1);
                document.cookie = "corporatePrivacyLevel=yes; path=/; expires=" + expiry.toGMTString();

                closePopup.call(this);
            });
        }

        //Landing popup
        const landingPopup = $('#popup-landing');
        if (landingPopup.length && document.cookie.indexOf("landingPopup=") < 0) {
            setTimeout(function () {
                $('.popup').removeClass("active");

                landingPopup.addClass("active").fadeIn(300);
                mainWrap.addClass("popup-open");

            }, 10000);

            landingPopup.find('.popup-close').on('click', function (e) {
                e.preventDefault();

                let expiry = new Date();
                expiry.setMonth(expiry.getMonth() + 1);
                document.cookie = "landingPopup=yes; path=/; expires=" + expiry.toGMTString();

                closePopup.call(this);
            });
        }
    });
}




// WEBPACK FOOTER //
// ./assets/js/modules/popups.js